exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5[data-v-9a4ae0ca]{font-weight:700;font-size:18px;margin-bottom:24px}h5[data-v-9a4ae0ca],p[data-v-9a4ae0ca]{color:#000}p[data-v-9a4ae0ca]{font-size:14px;line-height:1.5}img[data-v-9a4ae0ca]{max-width:100%}.visualisation[data-v-9a4ae0ca]{border:5px solid #fff;border-radius:17%}", ""]);

// exports
